module.exports = __webpack_public_path__ + "static/20invgde-fdc9b07b1ee09acdb5aab0ebf34adaed.gif";